// Długość trwania jednej klatki reklamy z obrazkiem
export const ADImageDelay = 20; // sek

// Jak długo ma wyświetlać się podgląd produktu
// Jak zmienisz tutaj to zmień także w kodzie api!
export const HideProductInfoDelay = 20; // sek
